import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getDossier: ["id"],
  dossierSuccess: ["dossier"],
  dossierFailure: null,
  saveDossier: ["dossier"],
});

export const DossierTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  dossier: null,
  fetching: null,
  error: null,
  errorMessage: null,
});

/* ------------- Reducers ------------- */

// request the avatar for a user
export const request = (state) =>
  state.merge({
    fetching: true,
    dossier: null,
    error: null,
    errorMessage: null,
  });

// successful avatar lookup
export const success = (state, action) => {
  const { dossier } = action;
  // console.log("success==", dossier);
  if (dossier.erreur !== undefined) {
    let errorMessage = dossier.erreur;
    if (errorMessage.includes("erreur serveur de sauvegade (id:")) {
      errorMessage =
        "Désolé, cet id de dossier n'existe pas dans notre système.";
    }
    return state.merge({
      dossier: state.dossier,
      fetching: false,
      error: true,
      errorMessage: errorMessage,
    });
  } else {
    return state.merge({
      fetching: false,
      error: null,
      dossier,
      errorMessage: null,
    });
  }
};

// failed to get the avatar
export const failure = (state) =>
  state.merge({
    fetching: false,
    error: true,
    dossier: null,
    errorMessage: "Erreur du serveur.",
  });

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_DOSSIER]: request,
  [Types.DOSSIER_SUCCESS]: success,
  [Types.DOSSIER_FAILURE]: failure,
  [Types.SAVE_DOSSIER]: success,
});
